import { render } from "./Footer.vue?vue&type=template&id=28634a99&scoped=true&ts=true&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=28634a99&scoped=true&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28634a99"]])

export default __exports__